export const $_fnNavGroup = "$_fnNavGroup";
